import { useChatComposerStore } from '@air/feature-ag-ui-chat/composer-store';

const COMPOSER_READY_TIMEOUT_MS = 1500;

/**
 * Resolves once the chat composer has registered its insert callbacks, or after a timeout.
 *
 * The composer builds its editor asynchronously after mount (TipTap `immediatelyRender: false`),
 * and the hero composer remounts whenever the chat sidebar is toggled — so for a frame after a
 * (re)mount `insertToken`/`insertSkill` are still null. Awaiting this lets a gallery CTA clicked
 * right after a toggle still insert reliably instead of no-opping.
 */
export function waitForComposerReady(timeoutMs = COMPOSER_READY_TIMEOUT_MS): Promise<boolean> {
  if (useChatComposerStore.getState().insertToken) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    let unsubscribe = () => {};

    const timer = setTimeout(() => {
      unsubscribe();
      resolve(false);
    }, timeoutMs);

    unsubscribe = useChatComposerStore.subscribe((state) => {
      if (state.insertToken) {
        clearTimeout(timer);
        unsubscribe();
        resolve(true);
      }
    });
  });
}
